// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoDataLabel_no-data__1AYq2"};